import { initFileViewerModal } from './file_viewer_zoom.js';

let depictorHandlersInstalled = false;

function jobIdComboboxEl(root) {
  var scope = root && root.querySelector ? root : document;
  return (
    scope.querySelector('#jobidmaster_pk[data-init="virtual-select"]')
    || document.getElementById('jobidmaster_pk')
  );
}

function resetJobIdCombobox(el) {
  if (!el) return;
  try {
    if (el.virtualSelect && typeof el.virtualSelect.destroy === 'function') {
      el.virtualSelect.destroy();
    }
  } catch (_e) {
    /* ignore stale VirtualSelect teardown */
  }
  el.removeAttribute('data-initialized');
}

function initJobIdCombobox(root) {
  if (typeof window.initVirtualSelect !== 'function') return false;
  var el = jobIdComboboxEl(root);
  if (!el || el.getAttribute('data-init') !== 'virtual-select') return false;
  resetJobIdCombobox(el);
  window.initVirtualSelect(el);
  var host = el.closest('[id$="_entryform"]') || el;
  if (window.htmx && typeof window.htmx.process === 'function') {
    window.htmx.process(host);
  }
  return el.hasAttribute('data-initialized');
}

function retryJobIdCombobox(root, attempt) {
  attempt = attempt || 0;
  if (initJobIdCombobox(root) || attempt >= 15) return;
  window.setTimeout(function () {
    retryJobIdCombobox(root, attempt + 1);
  }, 50);
}

function relocateStatusRowCount() {
  var slot = document.getElementById('depictor-status-rowcount-slot');
  if (!slot) return false;
  // The status grid renders its toolbar as the first <div> inside `<grid_name>:grid`.
  var gridContainer = document.getElementById('ssr-threedrawingdepictor-status:grid');
  if (!gridContainer) return false;
  var toolbar = gridContainer.firstElementChild;
  if (!toolbar || toolbar.tagName !== 'DIV') return false;
  if (toolbar.querySelector(':scope > [data-depictor-status-rowcount]')) return true;
  var badge = document.createElement('span');
  badge.dataset.depictorStatusRowcount = '1';
  badge.className = 'text-xs text-gray-500 whitespace-nowrap mr-auto pl-1';
  badge.textContent = slot.textContent.trim();
  toolbar.insertBefore(badge, toolbar.firstChild);
  return true;
}

function retryRelocateStatusRowCount(attempt) {
  attempt = attempt || 0;
  if (relocateStatusRowCount() || attempt >= 25) return;
  window.setTimeout(function () {
    retryRelocateStatusRowCount(attempt + 1);
  }, 60);
}

function relocateListingToolbar() {
  
  pruneListingWrapper();
  var slot = document.getElementById('depictor-listing-toolbar-slot');
  if (!slot) return false;
  // The listing_grid renders its toolbar as the first <div> inside `<grid_name>:grid`.
  var gridContainer = document.getElementById('ssr-threedrawingdepictor-listing:grid');
  if (!gridContainer) return false;
  var toolbar = gridContainer.firstElementChild;
  if (!toolbar || toolbar.tagName !== 'DIV') return false;
  var rightCluster = toolbar.querySelector(':scope > span:last-child');
  if (!rightCluster) return false;
  if (rightCluster.parentElement === slot) return true;
  while (slot.firstChild) slot.removeChild(slot.firstChild);
  slot.appendChild(rightCluster);
  return true;
}

function pruneListingWrapper() {
 
  var listingHeader = document.querySelector(
    'div#ssr-threedrawingdepictor[data-formname="threedrawingdepictor"]'
  );
  if (listingHeader) listingHeader.remove();
  
  var listingGrid = document.getElementById('ssr-threedrawingdepictor-listing:grid');
  if (listingGrid) {
    var listingGridShell = listingGrid.closest('.grid-refresh-container') || listingGrid;
    var shellContainsDataform = !!listingGridShell.querySelector(
      'div[id$="_entryform"]:not([data-formname])'
    );
    if (shellContainsDataform) {
      listingGrid.remove();
    } else {
      listingGridShell.remove();
    }
  }
  document.querySelectorAll('[hx-trigger="popstate from:window"]').forEach(function (el) {
    var url = el.getAttribute('hx-get') || '';
    if (url.indexOf('threedrawingdepictor/landing') !== -1) {
      el.remove();
    }
  });
 
  document.querySelectorAll(
    'div[id$="_entryform"][data-formname="threedrawingdepictor"]'
  ).forEach(function (wrap) {
    
    wrap.classList.remove('h-screen', 'h-[calc(100vh-5rem)]', 'flex', 'flex-col', '-mt-8');
    Array.from(wrap.children).forEach(function (child) {
      if (child.classList && child.classList.contains('h-full')) {
        child.classList.remove('h-full');
      }
    });
  });
}

function retryRelocateListingToolbar(attempt) {
  attempt = attempt || 0;
  if (relocateListingToolbar() || attempt >= 25) return;
  window.setTimeout(function () {
    retryRelocateListingToolbar(attempt + 1);
  }, 60);
}

function initThreeDDrawingDepictor(root) {
  root = root || document;
  installDepictorGlobalHandlers();
  if (!jobIdComboboxEl(root)) {
    initFileViewerModal();
    retryRelocateListingToolbar();
    retryRelocateStatusRowCount();
    return;
  }
  retryJobIdCombobox(root);
  window.requestAnimationFrame(function () {
    initJobIdCombobox(root);
  });
  initFileViewerModal();
  retryRelocateListingToolbar();
  retryRelocateStatusRowCount();
}

// Exposed for the SSR data-needs-init registry.
window.initThreeDDrawingDepictor = initThreeDDrawingDepictor;

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installDepictorGlobalHandlers);
  } else {
    installDepictorGlobalHandlers();
  }
}

// Open a front-report row as its own page. The custom landing can't render through
// the grid's in-place swap without nesting inside the listing wrapper and clipping
// the status grid, so we navigate like opening the record's URL directly. Capture +
// stopImmediatePropagation also suppresses the grid's default (nesting) open.
function openDepictorRecordFullPage(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('[id^="ssr-threedrawingdepictor-listing"]')) return;
  var row = event.target.closest('.ag-row');
  if (!row) return;
  var link = row.querySelector('a[href*="jobidmaster_pk"]');
  if (!link) return;
  var href = link.getAttribute('href');
  var token = new URLSearchParams(window.location.search).get('apitoken')
    || (document.querySelector("[name='apitoken']") || {}).value;
  if (token && href.indexOf('apitoken=') === -1) {
    href += (href.indexOf('?') >= 0 ? '&' : '?') + 'apitoken=' + encodeURIComponent(token);
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(href);
}

function closeFileViewerModal() {
  var modal = document.getElementById('file-viewer-modal');
  if (modal) modal.remove();
}

function installDepictorGlobalHandlers() {
  if (depictorHandlersInstalled) return;
  depictorHandlersInstalled = true;

  document.addEventListener('dblclick', openDepictorRecordFullPage, true);

  document.addEventListener('click', function (event) {
    var modal = document.getElementById('file-viewer-modal');
    if (!modal) return;
    if (!(event.target instanceof Element)) return;
    var target = event.target;
    if (
      target === modal
      || target.closest('#file-viewer-close-btn')
      || target.closest('#closeButton')
    ) {
      closeFileViewerModal();
      return;
    }
    var maximize = target.closest('#file-viewer-maximize-btn');
    if (!maximize) return;

    var container = document.getElementById('file-viewer-container');
    var pdfContainer = document.getElementById('viewer-pdf-container');
    if (!container) return;

    var isMaximized = container.dataset.maximized === 'true';
    container.dataset.maximized = isMaximized ? 'false' : 'true';
    container.classList.toggle('max-w-6xl', isMaximized);
    container.classList.toggle('max-h-[90vh]', isMaximized);
    container.classList.toggle('rounded-lg', isMaximized);
    container.classList.toggle('max-w-none', !isMaximized);
    container.classList.toggle('max-h-none', !isMaximized);
    container.classList.toggle('h-full', !isMaximized);
    container.classList.toggle('w-full', !isMaximized);
    container.classList.toggle('rounded-none', !isMaximized);
    maximize.title = isMaximized ? 'Maximize' : 'Restore';
    maximize.setAttribute(
      'aria-label',
      isMaximized ? 'Maximize viewer' : 'Restore viewer',
    );
    if (pdfContainer) {
      pdfContainer.classList.toggle('h-[600px]', isMaximized);
      pdfContainer.classList.toggle('h-full', !isMaximized);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFileViewerModal();
    }
  });
}
